import { render, staticRenderFns } from "../../../../components/shared/physicianSearch/BaseSearchResultsTemplate.html?vue&type=template&id=5fe47142&scoped=true&"
import script from "./SearchResultsPresenter.vue?vue&type=script&lang=js&"
export * from "./SearchResultsPresenter.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsPresenter.vue?vue&type=style&index=0&id=5fe47142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe47142",
  null
  
)

component.options.__file = "SearchResultsPresenter.vue"
export default component.exports